/*
 * Copyright 2024 Collaterate. All rights reserved.
 */

(function (window) {
    'use strict';

    // Dependencies
    var $ = window.jQuery;
    var controller = window.controller;
    var configureglobals = window.configureglobals;
    var common = window.common;
    var comet = window.comet;
    var TBGBOTip = window.TBGBOTip;
    var TBGBOLargeFormatTip = window.TBGBOLargeFormatTip;
    var tags = window.tags;
    var forms = window.forms;
    var confUtil = window.confUtil;
    var configureEvents = window.configureEvents;
    var chandler = window.chandler;

    // Constants
    var QUANTITYEF = 'QUANTITYEF';
    var QUANTITY_PER_VERSION_EF = 'QUANTITY_PER_VERSION_EF';
    var VERSION_COUNT_EF = 'VERSION_COUNT_EF';
    var QUOTEINPUTDATA = 'QUOTEINPUTDATA';

    // Comet Action Constants
    var REMOVE_VERSIONS = 'REMOVE_VERSIONS';
    var ADDVERSION = 'ADDVERSION';

    // Local Service Private Vars
    var onFocusVersionCount;

    // Public Service Definition
    window.quantityConfigureController = {
        generateQuantity: generateQuantity,
        addVersions: addVersions,
        removeVersions: removeVersions,
        onVersionCountFocus: onVersionCountFocus,
        onVersionCountBlur: onVersionCountBlur
    };

    return;

    function generateQuantity () {
        var qtyContent = '';
        var verContent = '';
        var cquotedata = configureglobals.cquotedata;

        var quantityPerVerFieldError = common.validation.hasJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF);
        var quantityFieldError = common.validation.hasJobQuoteFieldMessagesFor(QUANTITYEF);
        var versionCountFieldError = common.validation.hasJobQuoteFieldMessagesFor(VERSION_COUNT_EF);

        var jc = configureglobals.clpjc || configureglobals.cpjc;
        var tip = TBGBOTip || TBGBOLargeFormatTip;

        var help = '';

        var quantityPerVersion,
            versionCount,
            totalQuantity;

        if (jc.showQtyTip) {
            help = tags.a('', 'javascript:help.tip(configureglobals.' + (configureglobals.clpjc ? 'clpjc' : 'cpjc') + ',\'qtyTip\',\'' + tip.QUANTITY + '\')', {
                id: 'qtyTip',
                cssClass: 'quoteHelp',
                tabindex: '-1',
                title: 'More Information'
            });
        }

        if (jc.editQty || cquotedata.privilegedMode) {
            if (cquotedata.externallyGenerated || cquotedata.versions.length > 1) {
                quantityPerVersion = cquotedata.quantityPerVersion === null ? '' : cquotedata.quantityPerVersion;
                versionCount = cquotedata.versionCount === null ? '' : cquotedata.versionCount;
                totalQuantity = cquotedata.quantity;

                verContent += '<table class="version-quantity">';

                if (!cquotedata.externallyGenerated) {
                    verContent += '<tr class="quantity-per"><td>' + help + tags.label(cquotedata.versionQuantityLabel, {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(QUANTITY_PER_VERSION_EF, quantityPerVersion, {
                        size: 5,
                        cssClass: 'configField' + (quantityPerVerFieldError ? ' error' : ''),
                        onfocus: 'common.efFocus(\'' + QUANTITY_PER_VERSION_EF + '\',\'quantityPerVersion\', \'quantityPerVersionFocus\')',
                        onblur: 'common.efBlur(\'' + QUANTITY_PER_VERSION_EF + '\',\'quantityPerVersion\', \'quantityPerVersionFocus\')'
                    }) + '</td></tr>';

                    verContent += '<tr><td colspan="2"><span id="quantityPerVersionFocus" class="changeFocusButton"><!-- dynamic --></span></td></tr>';

                    if (quantityPerVerFieldError) {
                        verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(QUANTITY_PER_VERSION_EF) + '</td></tr>';
                    }

                    // TODO provide label from server.
                    verContent += '<tr class="quantity-per"><td>' + tags.label('Number of Versions', {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(VERSION_COUNT_EF, versionCount, {
                        size: 5,
                        id: VERSION_COUNT_EF,
                        cssClass: 'configField' + (versionCountFieldError ? ' error' : ''),
                        onfocus: 'quantityConfigureController.onVersionCountFocus()',
                        onblur: 'quantityConfigureController.onVersionCountBlur()'
                    }) + '</td></tr>';

                    verContent += '<tr><td colspan="2"><span id="versionsFocus" class="changeFocusButton"><!-- dynamic --></span></td></tr>';

                    if (versionCountFieldError) {
                        verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(VERSION_COUNT_EF) + '</td></tr>';
                    }
                } else {
                    verContent += '<tr class="quantity-per"><td>' + tags.label('Number of Versions', {
                        cssClass: 'config'
                    }) + '</td><td>';

                    verContent += forms.ef(VERSION_COUNT_EF, versionCount, {
                        cssClass: 'noEdit',
                        style: 'opacity : 1',
                        disabled: true
                    }) + '</td></tr>';
                }

                verContent += '<tr class="total-v-quantity"><td><span>' + cquotedata.quantityLabel + '</span></td><td>' + forms.ef(QUANTITYEF, totalQuantity, {
                    cssClass: 'noEdit version-total sum-quantity' + (quantityFieldError ? ' error' : ''),
                    style: 'opacity : 1',
                    disabled: true
                }) + '</td></tr>';

                if (quantityFieldError) {
                    verContent += '<tr><td colspan="2">' + common.validation.generateJobQuoteFieldMessagesFor(QUANTITYEF) + '</td></tr>';
                }

                verContent += '</table>';

                verContent += '<div class="versionButtons">';
                if (!cquotedata.externallyGenerated) {
                    verContent += '<a href="javascript:quantityConfigureController.removeVersions();" class="versionButton versionButton_remove">Remove Versions</a>';
                }
                verContent += '<a href="javascript:detailedVersionsController.open();" class="versionButton versionButton_details">Edit Versions</a>';
                verContent += '</div>';
            } else {
                qtyContent += help + tags.label(cquotedata.quantityLabel, {
                    cssClass: 'config'
                });

                qtyContent += forms.ef(QUANTITYEF, cquotedata.quantity ? cquotedata.quantity : '', {
                    size: 5,
                    cssClass: 'configField' + (quantityFieldError ? ' error' : ''),
                    onfocus: 'common.efFocus(\'' + QUANTITYEF + '\',\'quantity\', \'quantityFocus\')',
                    onblur: 'common.efBlur(\'' + QUANTITYEF + '\',\'quantity\', \'quantityFocus\')'
                });

                qtyContent += '<span id="quantityFocus" class="changeFocusButton"><!-- dynamic --></span>';

                if (quantityFieldError) {
                    qtyContent += common.validation.generateJobQuoteFieldMessagesFor(QUANTITYEF);
                }
            }

            if (!cquotedata.externallyGenerated && cquotedata.versions.length === 1 && jc.maxVersions > 1) {
                qtyContent += tags.a('Add Versions', 'javascript:quantityConfigureController.addVersions()', {
                    cssClass: 'addVersion'
                });
            }
        } else {
            qtyContent += tags.label(cquotedata.quantityLabel, {
                cssClass: 'config'
            });

            qtyContent += tags.div(cquotedata.quantity, {
                cssClass: 'noEdit'
            });
        }

        common.setOptionDiv('quantity', qtyContent);
        common.setOptionDiv('versions', verContent);
    }

    function addVersions () {
        var configChangeDetails = {
            context: 'addVersions',
            category: confUtil.OPTION_CHANGE,
            value: ''
        };

        var cometRequest = comet.newRequest(chandler, ADDVERSION, function (cometResponse) {
            common.setCQuoteData(cometResponse.getObject(QUOTEINPUTDATA));
            window.growlMessages.showAll(cometResponse);
            generateQuantity();
            common.ef = null;
            controller.getQuote(false, function () {
                configureEvents.onQuoteUpdated(configChangeDetails);
            });
        });

        configureEvents.onCalcChanged(configChangeDetails);
        cometRequest.send();
    }

    function removeVersions () {
        window.confirmPanel.confirm('Are you sure you want to remove all version?', function () {
            var configChangeDetails = {
                context: 'removeVersions',
                category: confUtil.OPTION_CHANGE
            };

            var cometRequest = comet.newRequest(chandler, REMOVE_VERSIONS, function (cometResponse) {
                common.setCQuoteData(cometResponse.getObject(QUOTEINPUTDATA));
                window.growlMessages.showAll(cometResponse);
                generateQuantity();
                common.ef = null;
                controller.getQuote(false, function () {
                    configureEvents.onQuoteUpdated(configChangeDetails);
                });
            });

            configureEvents.onCalcChanged(configChangeDetails);
            cometRequest.send();
        }, null, { confirmText: 'Remove' });
    }

    function onVersionCountFocus () {
        onFocusVersionCount = $('#' + VERSION_COUNT_EF).val();
        common.efFocus(VERSION_COUNT_EF, 'versions', 'versionsFocus');
    }

    function onVersionCountBlur () {
        var versions = configureglobals.cquotedata.versions;
        var updatedVersionCount = $('#' + VERSION_COUNT_EF).val();
        var hasCustomNames = false;

        if (updatedVersionCount < versions.length) {
            for (var index = updatedVersionCount; index < versions.length; index++) {
                if (versions[index].label !== versions[index].name) {
                    hasCustomNames = true;
                    break;
                }
            }

            if (hasCustomNames) {
                window.confirmPanel.confirm(
                    'By reducing the number of versions to ' + updatedVersionCount + ', you will lose one or more customized version names. Are you sure you wish to modify the number of versions?',
                    function () { // on save
                        common.efBlur(VERSION_COUNT_EF, 'versions', 'versionsFocus');
                    },
                    function () { // on cancel
                        $('#' + VERSION_COUNT_EF).val(onFocusVersionCount);
                    }
                );
            } else {
                common.efBlur(VERSION_COUNT_EF, 'versions', 'versionsFocus');
            }
        } else {
            common.efBlur(VERSION_COUNT_EF, 'versions', 'versionsFocus');
        }
    }
}(window));
